import React, { useEffect, useRef } from 'react';
import { Formik, Field } from 'formik';
import { InputField } from '../../../../components/formFields/InputField';
import { SelectFormField } from '../../../../components/formFields/SelectFormField';
import { objectEmptyCheck } from '../../../../utils/objectUtils';
import { getFieldErrors } from '../../../../utils/apiError';

interface RightsFormProps {
  formProps: Record<string, any>;
  submitOutside: boolean;
  submit: (values: any) => void;
  error?: any;
  reset?: boolean;
  resetConfirm?: () => void;
}

const RightsForm = ({
  formProps,
  submitOutside,
  submit,
  error,
  reset = false,
  resetConfirm,
}: RightsFormProps) => {
  const formRef = useRef<any>();

  useEffect(() => {
    if (reset === true) {
      formRef.current.setValues(formProps);
      resetConfirm();
    }
  }, [reset]);

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed && submitOutside) {
      formRef.current.submitForm();
    }

    return () => {
      isSubscribed = false;
    };
  }, [submitOutside]);

  useEffect(() => {
    formRef.current.setErrors(getFieldErrors(error));
  }, [error]);

  const init = ({ title, is_active }: any) => ({
    title,
    is_active,
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(values);
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <div className="space-y-1">
              <Field
                name="title"
                value={values.title}
                label="Název role"
                placeholder="Název role"
                component={InputField}
                data-testid="rights-form-title-input"
              />
              {!objectEmptyCheck(formProps) && (
                <SelectFormField
                  name="is_active"
                  label="Stav"
                  placeholder="Stav"
                  data-testid="rights-form-status-select"
                  data={[
                    { title: 'aktivní', id: 1 },
                    { title: 'neaktivní', id: 2 },
                  ]}
                />
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default RightsForm;
